/**
 * NGXS action dispatched when a partner arrives from an external (Tenapod) site
 * with sign-in credentials in the URL. Triggers a POST to
 * `/partner/tenapod/external-auth` and, on success, populates the user state the
 * same way `LoginAction` does.
 *
 * @param email          The partner email forwarded from the external site.
 * @param path           The target path the user wanted to land on after authentication.
 *                       Sent to the backend and used by the caller to navigate after success.
 * @param expirationDate Titkosított lejárati időbélyeg az URL `expiration_date`
 *                       query paraméteréből. A backend-nek változatlanul továbbítjuk
 *                       `expiration_date` body mezőként a tokenes auth ellenőrzéshez.
 */
export class TenapodExternalAuthAction {
  static type = '[USER] Tenapod External Auth';

  constructor(
    readonly email: string,
    readonly path: string,
    readonly expirationDate: string
  ) {}
}
